.wrapper {
    --code-block-line-numbers-width: 1ch;

    position: relative;
}

.wrapper[data-with-line-numbers] pre > code {
    padding-inline-start: calc(
        var(--mantine-spacing-md) * 2 + var(--code-block-line-numbers-width)
    );
}

.lineNumbers {
    position: absolute;
    z-index: 1;
    top: var(--mantine-spacing-xs);
    inset-inline-start: var(--mantine-spacing-md);
    width: var(--code-block-line-numbers-width);
    color: var(--mantine-color-dimmed);
    font-family: var(--mantine-font-family-monospace);
    font-size: var(
        --code-block-line-numbers-fz,
        calc(0.8125rem * var(--mantine-scale))
    );
    line-height: 1.7;
    text-align: end;
    white-space: pre;
    pointer-events: none;
    user-select: none;
}

@media (width < $mantine-breakpoint-sm), (pointer: coarse) {
    .wrapper div:has(> [data-variant='none']) {
        position: static;
        display: flex;
        justify-content: flex-end;
        border-radius: 0;
    }

    .wrapper [data-variant='none'] {
        width: 44px;
        height: 44px;
        opacity: 1;
    }

    .wrapper[data-with-controls] .lineNumbers {
        top: calc(44px + var(--mantine-spacing-xs));
    }
}
